import { render } from "./EditManagerModal.vue?vue&type=template&id=5651a530"
import script from "./EditManagerModal.vue?vue&type=script&lang=js"
export * from "./EditManagerModal.vue?vue&type=script&lang=js"

import "./EditManagerModal.vue?vue&type=style&index=0&id=5651a530&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__